import React from 'react'

import PageHeader from './components/Header'
import PageContent from './components/Content'

import './Page.scss'
import classy from 'shared/utils/classy'

export interface PageProps {
  children: React.ReactNode
  noPadding?: boolean
  noSpace?: boolean
  noScroll?: boolean
  'data-testid'?: string
}

const Page = ({
  children,
  'data-testid': dataTestId,
  noPadding = false,
  noSpace = false,
  noScroll = false,
}: PageProps) => {
  return (
    <main
      className={classy(
        'Page',
        noPadding && 'Page--no-padding',
        noSpace && 'Page--no-space',
        noScroll && 'Page--no-scroll',
      )}
      data-testid={dataTestId || 'page'}
    >
      {children}
    </main>
  )
}

Page.displayName = 'Page'

Page.Header = PageHeader
Page.Header.displayName = 'Page.Header'

Page.Content = PageContent
Page.Content.displayName = 'Page.Content'

export default Page
